import React from "react";
import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";
import { UserAvatar } from "components/Avatar/UserAvatar";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { DateWithTooltip } from "components/DateWithTooltip";
import DateRangeIcon from "@mui/icons-material/DateRange";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import buildUserName from "core/utils/build_user_name";
import { ActionCardMenu } from "components/CaseManagement/CaseDetail/Action/ActionCardMenu";

export default function ActionCard(props) {
  const { action, caseId } = props;

  const username = buildUserName(
    action?.assignee_detail ?? { unassigned: true }
  );

  return (
    <PaperWithMarginBottom elevation={3}>
      <CardWrapperGrid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Grid item xs={4}>
          <InnerGridRow>
            <Grid item xs={2}>
              <UserAvatar name={username} useAvatar />
            </Grid>
            <Grid item xs={10}>
              <AssigneeGrid>
                <Typography variant="body2" align="left">
                  {"Assigned to"}
                </Typography>
                <CardSubValue variant="body2" align="left">
                  {username}
                </CardSubValue>
              </AssigneeGrid>
            </Grid>
          </InnerGridRow>
        </Grid>
        <Grid item xs={2}>
          <Grid>
            <Typography variant="body2" align="left">
              {"Action"}
            </Typography>
            <CardSubValue variant="body2" align="left">
              {action?.action_type_detail?.name}
            </CardSubValue>
          </Grid>
        </Grid>
        <Grid item xs={2}>
          <Grid>
            <Typography variant="body2" align="left">
              {"Status"}
            </Typography>
            <CardSubValue variant="body2" align="left">
              {action?.action_status_detail?.name}
            </CardSubValue>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <InnerGridRow>
            <Grid container direction="row" alignItems="center" item xs={11}>
              <CalendarIcon />
              <GridCalendarMargin>
                <Typography variant="body2" align="left">
                  {"Due Date"}
                </Typography>
                <CardSubValue variant="body2" align="left">
                  {action?.requested_completion_date ? (
                    <DateWithTooltip
                      date={action.requested_completion_date}
                      showTime={false}
                    />
                  ) : (
                    <span>Not set</span>
                  )}
                </CardSubValue>
              </GridCalendarMargin>
            </Grid>
            <Grid item xs={1}>
              <ActionCardMenu
                action={action}
                menuIcon={<MoreHorizIcon />}
                caseId={caseId}
              />
            </Grid>
          </InnerGridRow>
        </Grid>
      </CardWrapperGrid>
    </PaperWithMarginBottom>
  );
}

ActionCard.propTypes = {
  action: PropTypes.object,
  caseId: PropTypes.number
};

const PaperWithMarginBottom = styled(Paper)`
  margin-bottom: 5px;
`;

const CardWrapperGrid = styled(Grid)`
  padding: 10px 16px;
  align-items: center;
`;

const CardSubValue = styled(Typography)`
  color: rgba(0, 0, 0, 0.54);
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CalendarIcon = styled(DateRangeIcon)`
  color: rgba(0, 0, 0, 0.54);
`;

const InnerGridRow = styled("div")`
  display: flex;
  align-items: center;
`;

const AssigneeGrid = styled(Grid)`
  padding-left: 16px;
  padding-right: 16px;
`;

const GridCalendarMargin = styled(Grid)`
  margin-left: 30px;
`;
